import { match, P } from 'ts-pattern';
import { BadRequestException } from '../exceptions/bad-request.exception';
import { ForbiddenException } from '../exceptions/forbidden.exception';
import { NotFoundException } from '../exceptions/not-found.exception';
import { ServerErrorException } from '../exceptions/server.exception';
import { UnauthorizedException } from '../exceptions/unauthorized.exception';
import { UnexpectedException } from '../exceptions/unexpected.exception';

export const formatExceptionToTitleAndDescription = (error: Error) =>
  match(error)
    .with(
      P.when((_error) => _error instanceof NotFoundException),
      () => ({
        title: 'Gezocht, maar niet gevonden',
        description:
          'We konden niet vinden wat je zocht. Misschien bestaat het niet meer, of klopt de link niet.',
      }),
    )

    .with(
      P.when((_error) => _error instanceof BadRequestException),
      () => ({
        title: 'Oops, dit klopt niet',
        description:
          'Er ging iets mis met de gegevens die we kregen. Kun je het nog eens proberen?',
      }),
    )

    .with(
      P.when((_error) => _error instanceof UnauthorizedException),
      () => ({
        title: 'Je bent niet ingelogd',
        description: 'Om dit te kunnen doen, moet je eerst even inloggen.',
      }),
    )

    .with(
      P.when((_error) => _error instanceof ForbiddenException),
      () => ({
        title: 'Geen toegang',
        description:
          'Je mag dit niet bekijken of doen. Heb je misschien niet de juiste rechten?',
      }),
    )

    .with(
      P.when((_error) => _error instanceof ServerErrorException),
      () => ({
        title: 'Er ging iets mis',
        description:
          'Onze server heeft het even moeilijk. Probeer het later opnieuw aub!',
      }),
    )

    .with(
      P.when((_error) => _error instanceof UnexpectedException),
      () => ({
        title: 'Uh oh, dit hadden we niet verwacht',
        description:
          'Er ging iets mis dat we niet hadden voorzien. Onze developers kijken wat er aan de hand is.',
      }),
    )

    .otherwise(() => ({
      title: 'Oops...',
      description:
        'Er is iets onverwachts misgegaan. Onze developers kijken wat er aan de hand is.',
    }));
